import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useBlocker } from '../../../hooks/useBlocker/useBlocker';

// Material UI
import Fab from '@mui/material/Fab';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

// Icons
import SaveIcon from '@mui/icons-material/Save';
import GetAppIcon from '@mui/icons-material/GetApp';
import DescriptionIcon from '@mui/icons-material/Description';

// Comonents
import DetailsTable from './details';
import { FabContainer } from '@arredo/reactjs-ui';
import SaveModal from './saveModal';
import AlertMovementModal from './AlertModal';
import Spinner from '../../../components/spinner';
import ModalConfirm from '../../../components/modal/confirm';
import { utils } from '../../../utils/utils';

// Hooks
import useReception from '../../../hooks/reception/useReception';
import useNotify from '../../../hooks/notify';
import useUser from '../../../hooks/user/useUser';

import useStyles from './styles';
import ReferralsModal from './referralsModal';

const MovementEdition = () => {
    const { classes } = useStyles();
    const user = useUser();
    const push = useNavigate();
    const { Notify, variants } = useNotify();
    const { movement, loading, edit, save, exportDetails } = useReception();

    // State
    const [openSave, setOpenSave] = useState();
    const [productNotContent, setProductNotContent] = useState();
    const [referralsModalOpen, setReferralsModalOpen] = useState(false);
    const [shouldBlockNavigation, setShouldBlockNavigation] = useState(true);
    const [openAlert, setOpenAlert] = useState(false);

    useEffect(() => {
        edit({ warehouseId: user.branch.warehouseId, branchCode: user.branch.code })
    }, [edit, user.branch.code, user.branch.warehouseId])

    useEffect(() => {
        window.onbeforeunload = shouldBlockNavigation
            ? () => true
            : undefined;

        return () => {
            window.onbeforeunload = undefined;
        }
    }, [shouldBlockNavigation])

    useBlocker((tx) => {
        if (shouldBlockNavigation && !window.confirm("Si te vas perderas todo el progreso realizado hasta ahora. ¿Estas seguro?")) {
            return;
        }
        tx.retry();
    }, shouldBlockNavigation);

    const handleOpenSaveModal = () => {
        edit({ ...movement, createdBy: user.email });
        if (!movement.products || movement.products.length <= 0)
            return Notify("El movimiento no tiene ningun detalle ingresado.", variants.INFO);
        if (!movement.products.some(i => i.quantity > 0))
            return Notify("Por favor ingresar las cantidades de los productos recibidos", variants.ERROR);
        if (movement.products.some(i => i.name.toLowerCase() === 'producto no encontrado'))
            return setProductNotContent(true);
        if (movement.products.some(i => i.quantity === 0))
            setOpenAlert(true)
        else setOpenSave(true);
    }

    const handleAcceptModalDelete = async () => {
        const deleteProduct = movement.products.filter(p => p.name.toLowerCase() !== 'producto no encontrado');
        edit({ ...movement, products: deleteProduct });
        setProductNotContent(false);
        setOpenSave(true);
    }

    const handleSaveMovement = async () => {
        if (!movement.warehouseId && !movement.warehouse?.id)
            return Notify("El usuario no tiene una sucursal asociada.", variants.ERROR);

        setShouldBlockNavigation(false);
        save()
            .then(() => {
                Notify(`Movimiento creado exitosamente.`, variants.SUCCESS);
                push('/movements');
            })
            .catch(err => {
                console.error(err);

                if (err?.Error === "WarningExceptions") {
                    Notify(`${err.message}`, variants.WARNING);
                    push('/movements');
                } else
                    Notify("Ocurrio un error al intentar guardar el movimiento.", variants.ERROR);
            })
            .finally(() => setShouldBlockNavigation(true));
    }

    const isInvalid = () =>
        !movement.products ||
        movement.products.length <= 0 ||
        movement.products.some(i => i.error) ||
        !movement.referrals ||
        movement.referrals.length <= 0;

    const handleDifferenceExport = async () => {
        const differences = movement?.products?.filter(p => p.difference !== 0);

        if (differences.length <= 0) {
            Notify("No hay diferencias que exportar", variants.INFO);
            return;
        }

        const blob = await exportDetails(differences);
        utils.export(blob, 'Reception_differences');
    }

    return (
        <>
            {
                loading &&
                <Spinner lockScreen />
            }
            {
                openSave &&
                <SaveModal
                    open={openSave}
                    movement={movement}
                    onChange={edit}
                    onClose={() => setOpenSave(false)}
                    onSave={handleSaveMovement}
                />
            }
            {
                productNotContent &&
                <ModalConfirm
                    open={productNotContent}
                    message="Hay productos que no se encontraron. ¿Estas seguro de seguir sin estos productos?"
                    onAccept={handleAcceptModalDelete}
                    onCancel={() => setProductNotContent(false)}
                    onClose={() => setProductNotContent(false)}
                />
            }
            {
                referralsModalOpen &&
                <ReferralsModal
                    open={referralsModalOpen}
                    onClose={() => setReferralsModalOpen(false)}
                    referralsAssigned={movement?.referrals}
                />
            }
            {
                openAlert &&
                <AlertMovementModal
                    open={openAlert}
                    onSave={() => setOpenSave(true)}
                    onClose={() => setOpenAlert(false)}
                />
            }
            <Grid container direction='column' spacing={2}>
                <Grid>
                    <Typography variant='h4' component='h2'>
                        Nuevo movimiento de recepción
                    </Typography>
                </Grid>
                <Grid>
                    <DetailsTable />
                </Grid>
            </Grid>
            <FabContainer>
                <Fab
                    color='primary'
                    variant="extended"
                    className={classes.fab}
                    onClick={handleDifferenceExport}
                >
                    <GetAppIcon className={classes.extendedIcon} />
                    Exportar diferencias
                </Fab>
                <Fab
                    color='primary'
                    variant="extended"
                    className={classes.fab}
                    onClick={() => setReferralsModalOpen(true)}
                >
                    <DescriptionIcon className={classes.extendedIcon} />
                    Remitos
                </Fab>
                <Fab
                    color='primary'
                    variant="extended"
                    className={classes.fab}
                    onClick={handleOpenSaveModal}
                    disabled={isInvalid()}
                >
                    <SaveIcon className={classes.extendedIcon} />
                    Guardar
                </Fab>
            </FabContainer>

        </>
    );
}

export default MovementEdition;